import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Check } from "lucide-react";

const SUBMISSION_IMAGE = "https://customer-assets.emergentagent.com/job_event-screen-1/artifacts/40cogh88_Welcome%20Email%20Kynn%20List.webp";

export default function SubmissionDialog({ open, onOpenChange, variant = "submitted" }) {
  const isVip = variant === "vip";

  // Keyed by `open` so the fade-up animation replays every time the dialog opens.
  const animKey = open ? "on" : "off";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="submission-dialog"
        className="border max-w-lg"
        style={{
          background: "#240F1C",
          borderColor: "rgba(221, 191, 207, 0.3)",
          color: "#F2EEE7",
          borderRadius: "2px",
        }}
      >
        <div className="p-2 sm:p-4" key={animKey}>
          <div
            className="w-12 h-12 flex items-center justify-center mb-6 fade-up"
            style={{
              background: isVip ? "#B9929D" : "rgba(185, 146, 157, 0.15)",
              color: isVip ? "#240F1C" : "#B9929D",
              borderRadius: "50%",
              animationDelay: "0ms",
            }}
          >
            <Check size={22} strokeWidth={2.5} />
          </div>

          {isVip && (
            <div
              className="small-caps mb-4 fade-up"
              style={{ color: "#B9929D", animationDelay: "120ms" }}
            >
              · Confirmed · Instant
            </div>
          )}

          <DialogTitle asChild>
            <h3
              className="font-display fade-up"
              style={{
                fontSize: "40px",
                lineHeight: 1.05,
                color: "#F2EEE7",
                letterSpacing: "-0.01em",
                animationDelay: isVip ? "180ms" : "120ms",
              }}
              data-testid="dialog-title"
            >
              {isVip ? (
                <>You're in.<br /><em style={{ color: "#DDBFCF" }}>Welcome back.</em></>
              ) : (
                <>Submission sent.<br /><em style={{ color: "#DDBFCF" }}>We'll be in touch.</em></>
              )}
            </h3>
          </DialogTitle>

          {isVip ? (
            <DialogDescription asChild>
              <p
                className="mt-5 fade-up"
                style={{
                  color: "#F2EEE7",
                  opacity: 0.8,
                  lineHeight: 1.7,
                  animationDelay: "260ms",
                }}
              >
                Your seat is held. We'll send the address and evening details the week of the salon. If plans change, please write us so someone else can take your seat.
              </p>
            </DialogDescription>
          ) : (
            <>
              <DialogDescription className="sr-only">
                Your application has been submitted successfully.
              </DialogDescription>
              <div
                className="mt-6 fade-up"
                data-testid="submission-image-wrap"
                style={{ animationDelay: "260ms" }}
              >
                <img
                  src={SUBMISSION_IMAGE}
                  alt="Kynn — thank you"
                  data-testid="submission-image"
                  className="w-full h-auto block"
                  style={{ borderRadius: "2px" }}
                />
              </div>
            </>
          )}

          <div
            className="mt-8 flex items-center gap-4 fade-up"
            style={{ animationDelay: isVip ? "360ms" : "400ms" }}
          >
            <button
              onClick={() => onOpenChange(false)}
              data-testid="dialog-close-btn"
              className="btn-primary"
            >
              {isVip ? "See you saturday" : "Close"} →
            </button>
            <span className="font-scribble" style={{ color: "#B9929D", fontSize: "20px" }}>
              — kynn
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
